// export type Concern = {
//   label: string, 
//   value: string
// }

export type Count = {
  label: string, 
  value: number,
  cost: number
}

export type MembershipCaclulatorState = {
  // organizationConcerns: Map<string, boolean>
  employeeCount: string
}

// const initialOrganizationConcerns = (): Map<string, boolean> => {
//   const concerns = new Map<string, boolean>()
//   concerns.set('concern_1', false)
//   concerns.set('concern_2', false)
//   concerns.set('concern_3', false)
//   concerns.set('concern_4', false)
//   concerns.set('concern_5', false)
//   return concerns
// }

export const initialMembershipCalculatorState: MembershipCaclulatorState = {
  // organizationConcerns: initialOrganizationConcerns(),
  employeeCount: 'count_2'
}
